import { render, staticRenderFns } from "./LoyaltyConfig.vue?vue&type=template&id=66df72b0"
import script from "./LoyaltyConfig.vue?vue&type=script&lang=js"
export * from "./LoyaltyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports